export default {
  // Data statistics
  totalData: "Total {count} records",

  // Loading
  loading: "Loading...",

  // Table columns
  currency: "Currency",
  balance: "Balance",

  // Empty state
  noWalletData: "No wallet balance data parsed from current investigation file",

  // Download
  downloadDetails: "Download Details",
  downloadFileName: "Data Details",
};
